import React from 'react'

const Briefcase = props => (
    <svg {...props}>
        <path d="M56.99 13.5H55v-3H45v3h-4V7.706A3.21 3.21 0 0037.794 4.5H22.206A3.21 3.21 0 0019 7.706V13.5h-4v-3H5v3H3.01A3.014 3.014 0 000 16.51v35.98a3.014 3.014 0 003.01 3.01h53.98A3.014 3.014 0 0060 52.49V16.51a3.014 3.014 0 00-3.01-3.01zm-9.99-1h6v1h-6v-1zM21 7.706c0-.665.541-1.206 1.206-1.206h15.588c.665 0 1.206.541 1.206 1.206V13.5H21V7.706zM19 15.5h31v38H10v-38h9zm-12-3h6v1H7v-1zM2 52.49V16.51c0-.557.453-1.01 1.01-1.01H8v38H3.01c-.557 0-1.01-.453-1.01-1.01zm56 0c0 .557-.453 1.01-1.01 1.01H52v-38h4.99c.557 0 1.01.453 1.01 1.01v35.98z"></path>
    </svg>
)

export default Briefcase
